<template>
  <div class="main-content">
    <div class="mc-top animate-target" v-animate-in>
      <SectionTitle icon="C" :title="title"></SectionTitle>
      <div class="btn btn_kerendia down-btn" @click="createPDf">Download certificate</div>
    </div>
    <div class="ctn-k animate-target" v-animate-in>
      <p><b>PBS Information:</b> Authority Required (STREAMLINED). <br/>Refer to PBS Schedule for full authority information.</p>
    </div>
    <div class="ctn-t1 animate-target" v-animate-in>
      Please review Product Information before prescribing. Full Product Information available at https://www.ebs.tga.gov.au/ebs/picmi/picmirepository.nsf/pdf?OpenAgent&id=CP-2021-PI02408 or upon request from Bayer Medical Information 1800 008 757
    </div>
    <div class="ctn-t2 animate-target" v-animate-in>
      ▼ This medicinal product is subject to additional monitoring in Australia. This will allow quick identification of new safety information. Healthcare professionals are asked to report any suspected adverse events at www.tga.gov.au/reporting-problems.
    </div>
    <div class="ctn-t3 animate-target" v-animate-in>
      <img src="../../assets/images/logo.png" />
      <p>Bayer Australia Ltd. ABN 22 000 138 714, 875 Pacific Highway, Pymble, NSW 2073.<br/>Kerendia<sup>®</sup> is a registered trademark of Bayer Group, Germany. PP-KER-AU-0305-2. April 2026.</p>
    </div>
    <div class="ctn-4 animate-target" v-animate-in>
      <div class="btn btn_kerendia down-btn" @click="toUrlHref">Submit Kerendia materials order form</div>
      <div class="btn btn_kerendia down-btn" @click="toUrlHref2">Submit your thoughts about the survey</div>
    </div>
    <div class="ctn-5 animate-target" v-animate-in>
      <p>More information and resources</p>
    </div>
    <div class="ctn-m animate-target" v-animate-in>
      <div class="ctn-n-item" @click="toUrl(1)">
        <img src="../../assets/images/p5-6/5-6-1.png" />
        <div>
          <span>Download patient booklet</span>
        </div>
      </div>
      <div class="ctn-n-item" @click="toUrl(2)">
        <img src="../../assets/images/p5-6/5-6-2.png" />
        <div>
          <span>Download prescriber guide</span>
        </div>
      </div>
      <div class="ctn-n-item" @click="toUrl(3)">
        <img src="../../assets/images/p5-6/5-6-3.png" />
        <div>
          <span>Download sample request form</span>
        </div>
      </div>
      <!--
      <img @click="toUrl(1)" src="../../assets/images/p5-6/5-6-1.png" />
      <img @click="toUrl(2)" src="../../assets/images/p5-6/5-6-2.png" />
      <img @click="toUrl(3)" src="../../assets/images/p5-6/5-6-3.png" />
      -->
    </div>
    <ExportPDF ref="childPDF"></ExportPDF>
  </div>
</template>

<script>
import ExportPDF from "../../components/ExportPDF";
import SectionTitle from "../../components/SectionTitle";
export default {
  name: "s7-5",
  components: {SectionTitle, ExportPDF},
  data() {
    return {
      title:'Module completed'
    }
  },
  methods:{
    toUrlHref() {
      window.open('https://forms.office.com/pages/responsepage.aspx?id=e7Oy_KBda0abgwAUtnp8ePg8mhwLYXJApmlbHckaT6VUQTQzUk5HME8zVDJKQk5DOVI1SDBKMTAyVSQlQCN0PWcu&route=shorturl', '_blank');
    },
    toUrlHref2() {
      window.open('https://forms.office.com/pages/responsepage.aspx?id=e7Oy_KBda0abgwAUtnp8eE-PNa2OFwNDpKgblByOMYdURUo4MTU5SzQ5WEtEWlZQMVZHVUxXV0dLSC4u&route=shorturl', '_blank');
    },
    toUrl(type) {
      console.log(type);
      if(type == 1) {

        window.gtag('event', 'PDF Download', {
          event_category: 'PDF Download',
          event_label: 'Download PDF - patient booklet',
          value: 1,
          send_to: 'G-GYZ3GY6CLF'
        });
        window.open('https://kidneyheartprotect.com.au/PatientBookletUpdate_V4_Singles.pdf', '_blank');
      }else if(type == 2) {

        window.gtag('event', 'PDF Download', {
          event_category: 'PDF Download',
          event_label: 'Download PDF - prescriber guide',
          value: 1,
          send_to: 'G-GYZ3GY6CLF'
        });
        window.open('https://kidneyheartprotect.com.au/Kerendia_Prescriber_Guide_18Jul25.pdf', '_blank');
      }else {

        window.gtag('event', 'PDF Download', {
          event_category: 'PDF Download',
          event_label: 'Download PDF - sample request form',
          value: 1,
          send_to: 'G-GYZ3GY6CLF'
        });
        window.open('https://kidneyheartprotect.com.au/KER-004087-01_Samples_Request_Form_2ppA4_Update_FA.pdf', '_blank');
      }
    },
    createPDf() {
      window.gtag('event', 'PDF Download', {
        event_category: 'PDF Download',
        event_label: 'Download certificate',
        value: 1,
        send_to: 'G-GYZ3GY6CLF'
      });
      const h = this.$createElement;
      let _this = this;
      this.$msgbox({
        title: "PLEASE ENTER YOUR FULL NAME",
        message: h(
          "div",
          {
            attrs: {
              class: "el-input"
            }
          },
          [
            h("input", {
              attrs: {
                placeholder: "PLEASE ENTER YOUR FULL NAME",
                class: "el-input__inner",
                autocomplete: "off",
                id: "commentContent"
              },
              value: this.commentContent,
              on: { input: this.onCommentInputChange }
            })
          ]
        ),
        showCancelButton: true,
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            done();
          } else {
            done();
          }
        }
      }).then(action => {
        _this.$refs.childPDF.createImage(_this.commentContent);
      });
    },
    onCommentInputChange() {
      this.commentContent = document.getElementById("commentContent").value;
    },
  }
}
</script>

<style scoped>
@import "../../assets/css/section5/s5.css";
.mc-top {
  width: 100%;
  display:flex;
}
.content-header {
  flex: 1;
  margin-right: 30px;
}
.down-btn {
  padding: 20px 40px;
  cursor: pointer;
}
.ctn-k {
  width: 100%;
  border: 3px solid #000;
  padding: 20px;
  display:flex;
  font-size: 24px;
  margin-top: 30px;
  align-items: center;
  justify-content: center;
}
.ctn-k b {
  font-weight: bold;
}
.ctn-t1 {
  font-size: 24px;
  margin-top: 20px;
}
.ctn-t2 {
  font-size: 20px;
  margin-top: 20px;
}
.ctn-t3 {
  margin-top: 20px;
  display:flex;
  align-items: center;
  justify-content: center;
}
.ctn-t3 img {
  width: 60px;
  margin-right: 40px;
}
.ctn-t3 p {
  flex: 1;
  font-size: 18px;
}
.ctn-4 {
  margin-top: 40px;
  padding-top: 30px;
  border-top: 2px solid #979797;
  font-size: 20px;
  color: #10384F;
  font-weight: bold;
  display:flex;
  justify-content: space-between;
  align-items: center;
}
.ctn-4 div {
  font-size: 20px;
  padding: 20px 30px;
  font-weight: normal;
}
.ctn-5 {
  margin-top: 0px;
  padding-top: 30px;
  font-size: 24px;
  color: #10384F;
  font-weight: bold;
  display:flex;
  justify-content: space-between;
  align-items: center;
}
.ctn-m {
  width: 100%;
  display:flex;
  gap: 30px;
  margin-top: 30px;
}
.ctn-m .ctn-n-item{
  flex: 1;
  width: calc(33% - 20px);
  background-color: RGB(216 216 216 / 25%);
  display:flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 30px 0px;
  cursor:pointer;
}
.ctn-m .ctn-n-item img {
  height: 180px;
  object-fit: contain;
  object-position: center;
}
.ctn-m .ctn-n-item div {
  width: 80%;
  margin-top: 30px;
}
.ctn-m .ctn-n-item span {
  display: flex;
  align-items: center;
  font-weight:bold;
}
.ctn-m .ctn-n-item span:after {
  content: ' ';
  width: 11px;
  height: 16px;
  background-image: url("../../assets/images/q-arrow.png");
  display: inline-block;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-left: 10px;
}

</style>
